import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M38 84q0-34 62-34t62 34v66q-30 22-62 22t-62-22Z\"></path><circle cx=\"78\" cy=\"100\" r=\"10\" fill=\"var(--mc-avatar)\"></circle><circle cx=\"122\" cy=\"100\" r=\"10\" fill=\"var(--mc-avatar)\"></circle><circle cx=\"78\" cy=\"100\" r=\"4\"></circle><circle cx=\"122\" cy=\"100\" r=\"4\"></circle><path fill=\"var(--mc-avatar)\" d=\"M80 134q20 10 40 0h-4l-16 22-16-22Z\"></path><path d=\"m34 86 16-26 6 28zM166 86l-16-26-6 28z\"></path>", 7)
  ]))]))
}
export default { render: render }